
import axios, { CancelTokenSource } from 'axios';
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';

@Component({
  components: {
    Multiselect,
  },
})
export default class CrudPicklistMultiSelect extends Vue {
  @Prop({ required: false, default: '/data-api/sf-picklist' })
  endpoint!: string;
  @Prop({ required: true }) picklistName!: string;
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: false }) selectOnly!: boolean;
  @Prop({ default: false }) allowEmptySearch!: boolean;
  @Prop({ default: Infinity }) maxResults!: number;
  @Prop() placeholder!: string;
  @Prop({ default: null }) value!: any;
  @Prop({ default: null }) flattenDelimiter!: string | null;
  @Prop() readonly disabled!: boolean;
  @Prop() readonly limitedOptions!: any[];

  isLoading: boolean = false;
  options: { label: string; valueName: string }[] = [];
  cancelSource: CancelTokenSource | null = null;

  created() {
    const queryString = `api_names=${this.picklistName}&values_only=true`;

    this.fetch(queryString);
  }

  get selected() {
    if (this.selectOnly || !this.value) {
      return undefined;
    }
    if (this.multiple) {
      const value = this.flattenDelimiter
        ? Array.isArray(this.value)
          ? this.value
          : this.value.split(this.flattenDelimiter)
        : this.value;
      return this.options.filter((o) => value.some((v) => o.valueName === v));
    }
    return this.options.find((o) => o.valueName === this.value);
  }

  set selected(data) {
    if (Array.isArray(data)) {
      const values = data?.map((v) => v.valueName);
      this.$emit(
        'input',
        this.flattenDelimiter ? values.join(this.flattenDelimiter) : values,
      );
    } else {
      this.$emit('input', data?.valueName);
    }
  }

  get showClear() {
    return (
      !this.selectOnly &&
      (Array.isArray(this.selected) ? this.selected.length : this.selected)
    );
  }

  async fetch(queryString: string) {
    if (this.cancelSource) {
      this.cancelSource.cancel();
    }
    this.isLoading = true;

    this.cancelSource = axios.CancelToken.source();
    return axios
      .get(`${this.endpoint}?${queryString}`, {
        cancelToken: this.cancelSource.token,
      })
      .then((result) => {
        let data = result.data.data ?? result.data;
        this.options = this.limitedOptions?.length
          ? data[this.picklistName].Metadata.customValue.filter((option) =>
              this.limitedOptions.includes(option.valueName),
            )
          : data[this.picklistName].Metadata.customValue;
        return this.options;
      })
      .finally(() => {
        this.isLoading = false;
        this.cancelSource = null;
      });
  }
}
